import 'react';

import GenericInputWrapper from './generic-wrapper/generic-input-wrapper';

const GenericTextInput = (
  {
    ref,
    ...props
  }
) => {
  return <GenericInputWrapper {...props} ref={ref} as="input" />;
};

GenericTextInput.displayName = 'GenericTextInput';

export default GenericTextInput;
